<template>
  <div data-testid="side-nav" v-if="clientload">
    <v-navigation-drawer
      data-testid="side-nav__drawer"
      :class="['nav-drawer','height-screen', mini ? 'mini-nav' : 'pa-4']"
      permanent
      touchless
      :width="drawerWidth"
    >
      <!-- Financial Close Sidebar extracted component -->
      <financial-close-menu
        data-testid="side-nav__financial-close-menu"
        v-if="$route.path.includes('financialclose')"
        :mini="mini"
        :selected-item="selectedItem"
        :open-menu="openMenu"
        :applist="applist"
        :fd-support-widget="fdSupportWidget"
        :chatbot-enabled="chatbotEnabled"
        :show-manuals="showManuals"
        @update:selectedItem="$emit('update:selectedItem', $event)"
        @update:openMenu="$emit('update:openMenu', $event)"
        @logout="$emit('logout')"
        @edit-profile="$emit('edit-profile')"
        @manuals-click="$emit('manuals-click')"
      />

      <!-- Sidebar for other than financial close -->
      <app-menu
        data-testid="side-nav__app-menu"
        v-else
        :mini="mini"
        :menu="$store.state.menu"
        :selected-item="selectedItem"
        :open-menu="openMenu"
        :applist="applist"
        :fd-support-widget="fdSupportWidget"
        :chatbot-enabled="chatbotEnabled"
        :show-manuals="showManuals"
        @update:selectedItem="$emit('update:selectedItem', $event)"
        @update:openMenu="$emit('update:openMenu', $event)"
        @logout="$emit('logout')"
        @edit-profile="$emit('edit-profile')"
        @manuals-click="$emit('manuals-click')"
      />
      
    </v-navigation-drawer>
  </div>
</template>

<script>
import FinancialCloseMenu from '../components/FinancialClose/FinancialCloseMenu.vue';
import AppMenu from './AppMenu.vue';

export default {
  name: 'SideNav',
  components: { FinancialCloseMenu, AppMenu },
  props: {
    clientload: { type: Boolean, default: false },
    mini: { type: Boolean, default: false },
    selectedItem: { type: String, default: null },
    openMenu: { type: Boolean, default: false },
    applist: { type: Array, default: () => [] },
    fdSupportWidget: { type: Boolean, default: false },
    chatbotEnabled: { type: Boolean, default: false },
    showManuals: { type: Boolean, default: false },
  },
  emits: ['update:selectedItem', 'update:openMenu', 'logout', 'edit-profile', 'manuals-click'],
  computed: {
    drawerWidth() {
      return this.mini 
        ? this.$constants.STYLES.SIZE.MINI_NAV 
        : this.$constants.STYLES.SIZE.EXPAND_NAV;
    },
    isFinancialClose() {
      return this.$route.path.includes('financialclose');
    }
  }
};
</script>

<style scoped>
/* Using global shared styles; no component-specific overrides needed */
.nav-drawer {
}

/* SVG icon hover effects for navigation */
:deep(.nav-img-icon) {
  transition: filter 0.2s ease;
}
/* Default state for icons */
:deep(.cycles-wrapper.cycles-has-data .v-list-item .nav-img-icon) {
  filter: brightness(0) saturate(100%);
}
/* Ensure SVG icons in tooltips also get hover effect */
:deep(.v-tooltip__content .nav-img-icon) {
  filter: brightness(0) saturate(100%);
}

/* Specific targeting for menu items */
:deep(.nav-standard-item:hover .nav-img-icon),
:deep(.menu-trigger-item:hover .nav-img-icon),
:deep(.v-list-item--active.nav-standard-item .nav-img-icon),
:deep(.appmenu-slide-group .v-list-item--active .nav-img-icon),
:deep(.nav-standard-item:focus .nav-img-icon, .selected-menu-item:focus .nav-img-icon),
:deep(.selected-menu-item .nav-img-icon) {
  filter: brightness(0) saturate(100%);
}
</style>